import Select from 'react-select'
//css
import './WSSelect.scss'

// interface Props {
//   placeholder?: any
//   className?: string
//   name?: string
//   value?: any
//   label?: string
//   disabled?: boolean
//   defaultValue?: string | string[] | any
//   onChange?: any
//   selectList?: any
//   isMulti?: boolean
// }

export const WSSelect = ({onChange, options, value, label, name, className, placeholder}: any) => {
  const defaultValue = (options: any[], value: any) => {
    return options ? options.find((option: any) => option.value === value) : ''
  }

  return (
    <>
      {/* <label className='form-label'>{label}</label> */}
      <Select
        name={name}
        value={defaultValue(options, value)}
        options={options}
        onChange={(value: any) => onChange(value)}
        className={`common-select ${className}`}
        placeholder={placeholder}
        isSearchable={false}

        // defaultMenuIsOpen
      />
    </>
  )
}
